'use strict';

angular
  .module('systemOwnerReviewControllers.DecommissionSystems')

  .controller('ExplanationDecommissionSystemsController', [
    '$scope',
    '$state',
    '$translate',
    'topBar',
    function ($scope, $state, $translate, topBar) {
      $translate('iam.admin.systemOwnerReview.decommissionSystems.pageTitle').then(function (translation) {
        topBar.setTitleAndIcon(translation, 'fa-chain-broken');
      });

      var todayDate = moment();
      var currentYear = todayDate.format('YYYY');
      todayDate = moment(currentYear + '-03-04');

      $scope.todayDay = todayDate.date();
      $scope.todayMonth = todayDate.format('MMMM');

      todayDate.add(60, 'days');

      $scope.archivedDay = todayDate.date();
      $scope.archivedMonth = todayDate.format('MMMM');

      todayDate.add(60, 'days');

      $scope.deletionDay = todayDate.date();
      $scope.deletionMonth = todayDate.format('MMMM');

      $scope.goToNextExplanationStep = function (step) {
        $state.go(
          'systemOwnerReview.authUser.decommissionSystemsExplanationStep' + step,
          { authLogin: $scope.authLogin },
          { reload: true }
        );
      };
    },
  ]);
